/* tl-cachebust-20260907-setsale1 — set sale lock vs Shopify list */
(function () {
  var p = (location.pathname || '').toLowerCase();
  if (/\/products\/(sauteerpan|twee-handgrepen|wok-vlakke-bodem|hoge-rand|diepe-pan|crepepan|kookpan)(?:\/|$)/.test(p)) return;
  if (/\/products\/[^/]*(ice-cube|straw|utensil)/.test(p)) return;

  var CATALOG_EUR = {
    'titanium-hammered-pan-pro-small': { price: 9500, compare: 15800 },
    'titanium-hammered-pan-pro-medium': { price: 10000, compare: 16700 },
    'titanium-hammered-pan-pro-large': { price: 10500, compare: 17500 },
    sauteerpan: { price: 11900, compare: 19800 },
    'twee-handgrepen': { price: 11900, compare: 19800 },
    'chefs-pan-set-2': { price: 12900, compare: 32500 },
    'chefs-pan-set-3': { price: 16800, compare: 50000 },
    'chefs-pan-set-3-pans-titanium-utensils': { price: 25400, compare: 64000 },
    'titanium-cutting-board-shop': { price: 9400, compare: 15667 },
    'titanium-cutting-board-bundle': { price: 13400, compare: 22333 },
    'titanium-utensil-set-bundle': { price: 8400, compare: 14000 },
    'titanium-straws': { price: 5400, compare: 9000 },
    'titanium-ice-cubes': { price: 5400, compare: 9000 }
  };

  function isEurMarket() {
    var path = (location.pathname || '').toLowerCase();
    if (path === '/nl' || path.indexOf('/nl/') === 0) return true;
    var cur = window.Shopify && Shopify.currency && Shopify.currency.active;
    if (cur === 'EUR') return true;
    return /€/.test(document.body ? document.body.innerText.slice(0, 4000) : '');
  }

  function productHandle() {
    var sec = document.querySelector('[data-tl-pdp-handle]');
    if (sec) return (sec.getAttribute('data-tl-pdp-handle') || '').toLowerCase();
    var m = (location.pathname || '').match(/\/products\/([^/?#]+)/i);
    return m ? decodeURIComponent(m[1]).toLowerCase() : '';
  }

  function handleFromHref(href) {
    var m = (href || '').match(/\/products\/([^/?#]+)/i);
    return m ? decodeURIComponent(m[1]).toLowerCase() : '';
  }

  function euro(cents) {
    if (!cents && cents !== 0) return '';
    return '€' + Math.round(cents / 100);
  }

  function pctOff(price, compare) {
    if (!compare || compare <= price) return 0;
    return Math.round((1 - price / compare) * 100);
  }

  function stripTrailingZeros(text) {
    return text && String(text).replace(/([,.])00(?!\d)/g, '');
  }

  function replaceDollarPrice(text, next) {
    return !text || !next ? text : String(text).replace(/\$[\d.,]+/g, next);
  }

  function applyEurToEl(el, now) {
    if (!el || !now) return;
    var t = (el.textContent || '').trim();
    if (!t || t.indexOf('€') === 0) {
      if (t !== now) el.textContent = now;
    } else if (/\$/.test(t)) {
      el.textContent = now;
    }
  }

  function paintSaleBox(box, cat) {
    if (!box || !cat) return;
    var now = euro(cat.price);
    var was = cat.compare && cat.compare > cat.price ? euro(cat.compare) : '';
    var off = was ? pctOff(cat.price, cat.compare) : 0;
    var mark = now + '|' + was + '|' + off;
    if (box.getAttribute('data-tl-sale') === mark) return;
    box.setAttribute('data-tl-sale', mark);
    if (!was) {
      box.textContent = now;
      return;
    }
    box.innerHTML =
      '<span class="tsc-card__now twt-price-now tl-card-now">' +
      now +
      '</span> <s class="tsc-card__compare twt-price-was tl-card-was">' +
      was +
      '</s> <span class="tsc-card__pct twt-price-pct tl-card-pct">−' +
      off +
      '%</span>';
  }

  function ensureBadge(card, off) {
    if (!off || !card) return;
    var existing = card.querySelector('.tsc-badge, .tl-card-badge, .sale-badge');
    if (existing) {
      var t = (existing.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/−?\d+%/.test(t)) existing.textContent = '−' + off + '%';
      return;
    }
    var media = card.querySelector('.tsc-card__media, .twt-card-media, .product-image-container, .card__media');
    if (!media) return;
    if (window.getComputedStyle(media).position === 'static') media.style.position = 'relative';
    var b = document.createElement('span');
    b.className = 'tsc-badge tl-card-badge';
    b.textContent = '−' + off + '%';
    media.appendChild(b);
  }

  function fixPdpCatalogEur() {
    if (!isEurMarket()) return;
    var handle = productHandle();
    var cat = CATALOG_EUR[handle];
    if (!cat) return;
    var now = euro(cat.price);
    var was = cat.compare ? euro(cat.compare) : null;
    var save = cat.compare && cat.compare > cat.price ? euro(cat.compare - cat.price) : null;
    document.querySelectorAll('.shop-product-price-block').forEach(function (el) {
      applyEurToEl(el, now);
    });
    if (was) {
      document.querySelectorAll('.shop-compare-price').forEach(function (el) {
        var t = (el.textContent || '').trim();
        if (!t || /\$/.test(t) || t !== was) el.textContent = was;
      });
    }
    if (save) {
      document.querySelectorAll('[data-save-dollar]').forEach(function (el) {
        el.textContent = save;
      });
    }
    document
      .querySelectorAll(
        '.sticky-add-to-cart .price, #stickyAddToCart .price, .shop-add-to-cart-button .button-text, [data-ss-price], .price-item--regular, .price__regular'
      )
      .forEach(function (el) {
        var t = el.textContent || '';
        if (/\$/.test(t)) el.textContent = replaceDollarPrice(t, now);
      });
  }

  function fixCardPrices(root) {
    if (!isEurMarket()) return;
    (root || document).querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      if (link.closest('cart-drawer,#CartDrawer,#main-cart-items,.cart-item,.tl-line-price,#tl-pan-buybox,[data-tgem-buy],[data-tl-line-card]')) {
        return;
      }
      if (link.hasAttribute('data-tl-line-card')) return;
      var handle = handleFromHref(link.getAttribute('href') || '');
      var cat = CATALOG_EUR[handle];
      if (!cat) return;
      var card =
        link.closest(
          '.twt-card, .tsc-card, .tss-card, .product-card, .card-wrapper, li[data-title], li.grid__item, li.tl-col-grid__item, .tl-col-card, .tl-acc-card, a.tl2-set, article.tl-chefs-sets__card, .tl-pdp2-set'
        ) || (link.classList.contains('tsc-card') || link.classList.contains('tl-col-card') ? link : null);
      if (!card) return;
      var box = card.querySelector(
        '.tsc-card__price, .twt-card-price, .collection-product-price, .card-information .price, .price, .tl-col-card__price, .tl-acc-card__price, .tl2-meta strong, .tl-chefs-sets__amounts, .tl-pdp2-set__price'
      );
      if (!box && link.classList.contains('tsc-card')) box = link.querySelector('.tsc-card__price');
      if (box) paintSaleBox(box, cat);
      ensureBadge(card, pctOff(cat.price, cat.compare));
    });
  }

  function polishPriceContainer(container) {
    if (!container || container.getAttribute('data-tl-price-polished') === '1') return;
    container.setAttribute('data-tl-price-polished', '1');
    var priceEl = container.querySelector('.shop-product-price-block');
    var compareEl = container.querySelector('.shop-compare-price');
    var saveEl = container.querySelector('.shop-save-price');
    var dollarEl = container.querySelector('[data-save-dollar]');
    if (priceEl) priceEl.textContent = stripTrailingZeros(priceEl.textContent.trim());
    if (compareEl) compareEl.textContent = stripTrailingZeros(compareEl.textContent.trim());
    if (saveEl && dollarEl) dollarEl.textContent = stripTrailingZeros(dollarEl.textContent.trim());
    else if (saveEl) saveEl.textContent = stripTrailingZeros(saveEl.textContent.trim());
  }

  function polishAll() {
    fixPdpCatalogEur();
    fixCardPrices(document);
    document.querySelectorAll('.shop-product-price-container').forEach(polishPriceContainer);
  }

  function bindUpdates() {
    ['simple-variant-picker:variantChange', 'quantity:changed', 'quantity_break:changed', 'subscriptionContext:updated'].forEach(
      function (name) {
        document.addEventListener(name, function () {
          document.querySelectorAll('.shop-product-price-container').forEach(function (el) {
            el.removeAttribute('data-tl-price-polished');
          });
          setTimeout(polishAll, 30);
        });
      }
    );
  }

  function schedule() {
    polishAll();
    setTimeout(polishAll, 400);
    setTimeout(polishAll, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      schedule();
      bindUpdates();
    });
  } else {
    schedule();
    bindUpdates();
  }

  try {
    var busy = false;
    var t = 0;
    new MutationObserver(function () {
      if (busy) return;
      clearTimeout(t);
      t = setTimeout(function () {
        busy = true;
        try {
          fixCardPrices(document);
          fixPdpCatalogEur();
        } finally {
          busy = false;
        }
      }, 200);
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
